<template>
  <i class="rounded-sm flag-icon flex-shrink-0" :class="`flag-icon-${country.replace('en', 'gb')}`" :title="country" />
</template>

<script>
  export default {
    name: 'UiFlag',
    props: {
      country: {
        type: String,
        required: true,
      },
    },
  }
</script>